/**
     * @desc 明细
包含菜单和按钮信息，但不包含视图信息
     */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<defs.appCenter.AppDomainMenuAggregateResponseDto>;
export function request(code: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/menu/${code}`, {
      method: "GET",

      ...options,
    }),
  );
}
